import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Uses the httpOnly session cookie (Emergent Google Auth) for all requests,
// including /api/admin/* — the backend enforces email-based admin guard.
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;
